import { render, staticRenderFns } from "./DonutChart308.vue?vue&type=template&id=665b85c8&scoped=true"
import script from "./DonutChart308.vue?vue&type=script&lang=js"
export * from "./DonutChart308.vue?vue&type=script&lang=js"
import style0 from "./DonutChart308.vue?vue&type=style&index=0&id=665b85c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b85c8",
  null
  
)

export default component.exports